import React, {PropsWithChildren} from 'react';

export const PreventBubble: React.FC<
  PropsWithChildren<{
    className?: string;
  }>
> = ({children, className}) => (
  <span
    className={className}
    onClick={(e) => {
      e.stopPropagation();
    }}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.stopPropagation();
      }
    }}
  >
    {children}
  </span>
);
